import { useTranslation } from 'react-i18next';
import Link from '../../components/Links/link';
import DescriptionSplit from '../../components/Description/description-split';

export default function ExpiredStepPaymentLink() {
    const { t } = useTranslation();

    return (
        <section className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-8">
            <div className="bg-white rounded-xl shadow-lg p-6 sm:p-10 max-w-lg w-full text-center">
                {/* Title */}
                <h1 className="text-2xl sm:text-3xl font-semibold text-primary mb-8">
                    {t('pagePaymentLink.expired.title')}
                </h1>

                {/* Description */}
                <DescriptionSplit
                    description={t('pagePaymentLink.expired.description')}
                    opacity="100"
                    className="text-gray-600 leading-relaxed mb-6"
                />

                {/* Action Button */}
                <Link link="/" disableHoverEffect>
                    <button className="w-full sm:w-auto bg-primary text-white px-6 py-3 rounded-lg font-medium shadow-md hover:bg-primary/90 transition-colors">
                        {t('pagePaymentLink.expired.button')}
                    </button>
                </Link>
            </div>
        </section>
    );
}